module.exports = __webpack_public_path__ + "fonts/1320765013cf9d15c8a5628d4f4d67eb.svg";